<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p><span dir="rtl">إلى عائلتي الغالية، وإلى رفاق دربي القرَّاء، وإلى وطني لبنان شعاع النورِ.. أرفع يدي وقلبي شكرًا وتقديرًا لكلِّ مَن ساهم في وُلوج هذا الكتاب إلى حيِّز الوجود.</span></p>
<p><span dir="rtl">إليكم أيها الأحبَّة رسالةَ شكرٍ مليئةً بالامتنان والعرفان.</span></p>
<p><span dir="rtl">أشكُرُ عائلتي الحبيبة، وزوجي وأولادي على إعطائي الدعم والقوَّة للإبداع.</span></p>
<p><span dir="rtl">أودُّ أن أعبِّرَ عن شكري الخالص لكلِّ قُرَّائي الأعزَّاء، أنتم مَن منحتموني السرورَ والفخرَ بتقديم هذا العمل</span>.</p>
<p><span dir="rtl">ولكلِّ مَن ساهم في هذا الكتاب، أسرة أوستن ماكولي، مِن محرِّرين وناقدين ومصمِّمين، أتوجَّه بكلِّ الامتنان لجهودكم المتميِّزة ومساهمتكم القَيِّمة</span>.</p>
<p><span dir="rtl">في النهاية، أودُّ أن أمدَّ يدي بخالص الشكر والامتنان لدولة الإمارات العربية المتحدة، الأرض التي استقبلَتني بذراعين مفتوحتَين وكانت خلفيةً ملهمة لسعْيي الإبداعي.</span></p>
<p><span dir="rtl">ثقافةُ الإمارات الحيويَّة وتراثُها الغني أثَّرا بشكل عميق في رحلتي ككاتبة.</span></p>
<p><span dir="rtl">أنا ممتنَّة لهذه الدولة الرائعة على الفرص التي منحَتها لي وعلى الضيافة الدافئة التي تلقَّيتُها مِن أهلها.</span></p>
<p><span dir="rtl">دعمكم وتشجيعكم قد أثَّر في اشتعال شغفي بفنِّ الشعر والنثر والرواية.</span></p>
<p><span dir="rtl"><br/>
</span></p>
<p style="text-align:center"><img alt="" src="media/file1.jpg" style="width:70%;height:5.5in"/></p>
<p><strong><span dir="rtl"><br/>
</span></strong></p>
<div class="figure">
<img alt="" src="media/file2.jpg" style="width:70%;height:6.5in"/>
<p class="caption">A lawn with flowers and trees in front of a building Description automatically generated</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?83258496